import React from 'react';
import { Switch } from '../../../../../../components/common/Switch';
import { Select, Input } from '../../../../../../components/common/FormFields';
import { useUserSettings } from '../../../../../../hooks/useUserSettings';

const SettingsTab = () => {
  const { settings, updateSettings } = useUserSettings();
  const mapSettings = settings?.preferences?.mapSettings || {};

  const zoomLevels = [
    { value: 'far', label: 'Far (Zoom 1-7)' },
    { value: 'medium', label: 'Medium (Zoom 8-14)' },
    { value: 'close', label: 'Close (Zoom 15+)' }
  ];

  const handleSettingChange = async (key, value) => {
    await updateSettings({
      preferences: {
        ...settings.preferences,
        mapSettings: {
          ...mapSettings,
          [key]: value
        }
      }
    });
  };

  return (
    <div className="p-4 space-y-6">
      <h2 className="text-lg font-medium text-white">Map Settings</h2>

      
       

      {/* Route Display Settings */}
      <h2 className="text-lg font-medium text-white mt-8 mb-4">Route Display</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-gray-400 mb-2">Line Width</label>
          <Input
            type="range"
            min="1"
            max="10"
            value={mapSettings.routeLineWidth || 4}
            onChange={(e) => handleSettingChange('routeLineWidth', parseInt(e.target.value))}
            className="w-full"
          />
          <div className="text-sm text-gray-400 mt-1">
            {mapSettings.routeLineWidth || 4}px
          </div>
        </div>

        <div>
          <label className="block text-gray-400 mb-2">Line Opacity</label>
          <Input
            type="range"
            min="0"
            max="100"
            value={(mapSettings.routeOpacity || 1) * 100}
            onChange={(e) => handleSettingChange('routeOpacity', parseInt(e.target.value) / 100)}
            className="w-full"
          />
          <div className="text-sm text-gray-400 mt-1">
            {Math.round((mapSettings.routeOpacity || 1) * 100)}%
          </div>
        </div>
      </div>

      {/* POI Display Settings */}
      <h2 className="text-lg font-medium text-white mt-8 mb-4">POI Display</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-gray-400 mb-2">POI Size by Zoom Level</label>
          {zoomLevels.map((level) => (
            <div key={level.value} className="mb-4">
              <label className="block text-sm text-gray-400 mb-1">{level.label}</label>
              <Input
                type="range"
                min="16"
                max="48"
                value={mapSettings.poiSizes?.[level.value] || 32}
                onChange={(e) => handleSettingChange('poiSizes', {
                  ...mapSettings.poiSizes,
                  [level.value]: parseInt(e.target.value)
                })}
                className="w-full"
              />
              <div className="text-sm text-gray-400 mt-1">
                {mapSettings.poiSizes?.[level.value] || 32}px
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Cluster Display Settings */}
      <h2 className="text-lg font-medium text-white mt-8 mb-4">Cluster Display</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-gray-400 mb-2">Cluster Size by Zoom Level</label>
          {zoomLevels.map((level) => (
            <div key={level.value} className="mb-4">
              <label className="block text-sm text-gray-400 mb-1">{level.label}</label>
              <Input
                type="range"
                min="24"
                max="64"
                value={mapSettings.clusterSizes?.[level.value] || 40}
                onChange={(e) => handleSettingChange('clusterSizes', {
                  ...mapSettings.clusterSizes,
                  [level.value]: parseInt(e.target.value)
                })}
                className="w-full"
              />
              <div className="text-sm text-gray-400 mt-1">
                {mapSettings.clusterSizes?.[level.value] || 40}px
              </div>
            </div>
          ))}
        </div>
      </div>

      
    </div>
  );
};

export default SettingsTab;